// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { SaveButton as RaSaveButton, SaveButtonProps } from 'react-admin';

import { PermissionActionT } from '@Common/types/bo/authorization';
import { BOResourceAll } from '@Common/types/bo_external/resources';

import { useCanAccess } from '@sh4res/bo-common/hooks';

export interface SaveButtonPropsI extends SaveButtonProps {
  testId?: string;
  readonly permissions: {
    readonly resource: BOResourceAll;
    readonly action: PermissionActionT;
  };
}

export function SaveButton({
  permissions: { resource, action },
  testId,
  ...props
}: SaveButtonPropsI) {
  const canAccess = useCanAccess({
    resource,
    action,
  });

  if (canAccess) {
    return <RaSaveButton {...props} data-testid={testId} disableElevation={true} />;
  }

  return null;
}
